import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import useDocumentScrollThrottled from './UseDocumentScrollThrottled';

const Header = ({ context }) => {
    
    const ctxGlobal 	= () => context.global;
	const global 		= ctxGlobal();
	
	function handleMenuToggle(evt) {
	  	evt.preventDefault();
	  	context.toggleMenu();
  	}
			
    if (context.global) {
						
		if (global.json === null) {
			context.getGlobal(window.location.origin + '/wp-json/sync/v1/global');
		}
	  		  	
	  	if (global.json !== null) {  
		  	
			return (
				<>
			    	<header className="c-header">
						<h2 className="c-header__logo">
							<Link to={{ pathname: '/' }} className="c-header__logo__inner" dangerouslySetInnerHTML={ {__html: '<svg viewBox="0 0 100 48"><path d="m40.76 29.4h-4.7c-1.59 0-2.58-0.66-2.58-1.99v-27.41h-7.35v29.46 0.08c0.02 4 3.28 7.23 7.28 7.21h7.28v1.92c0 1.46-0.4 1.99-2.05 1.99h-5.23v7.34h7.35c4-0.06 7.22-3.29 7.28-7.28v-40.72h-7.28v29.4zm-25.63-29.4h-7.54c-4 0.06-7.22 3.29-7.28 7.28v6.02c0 3.51 2.51 4.9 4.9 6.09 2.45 1.19 4.63 2.45 7.08 3.84 1.06 0.6 2.58 1.26 2.58 2.65v1.53c0 1.46-0.4 1.99-2.05 1.99h-3.11c-1.46 0-1.99-0.46-1.99-2.12v-1.92h-7.35v4.03c0.04 3.99 3.23 7.23 7.22 7.35h7.35c4-0.06 7.22-3.28 7.28-7.28v-6.29c0-3.51-2.52-4.9-4.9-6.09-2.45-1.19-4.63-2.45-7.08-3.84-1.06-0.6-2.58-1.26-2.58-2.65v-1.25c0-1.46 0.4-1.99 2.05-1.99h3.31c1.46 0 1.99 0.46 1.99 2.12v1.92h7.35v-4.04c-0.05-3.99-3.24-7.23-7.23-7.35zm51.46 0h-14.64v36.74h7.35v-29.4h4.63c1.32 0 2.58 0.53 2.58 1.99v27.41h7.36v-29.46-0.05c-0.02-4-3.28-7.24-7.28-7.23zm33.1 22.47h-7.56v6.92h-4.42c-1.59 0-2.58-0.66-2.58-1.99v-18.07c0-1.46 0.4-1.99 2.05-1.99h4.95v6.87h7.56v-14.21h-14.63c-4 0.06-7.22 3.29-7.28 7.28v22.18c-0.02 4 3.2 7.26 7.21 7.28h0.08 14.63l-0.01-14.27z"/></svg>'}}></Link>
						</h2>
						<a href="#" className="c-header__menu-button" onClick={handleMenuToggle}>
							<span>Menu</span>
						</a>
						<ul className="c-header__list">
							{global.json.menu.map((item,i) =>
								{
									let location = window.location + '';
									let linkClass = 'c-header__link';
									if (location.indexOf(item.url) !== -1) {
										linkClass = 'c-header__link state-active';
									}
									if (i !== 0) {										
										return (
											<li className="c-header__item" key={i}>
												<Link to={{ pathname: item.url }} className={linkClass} dangerouslySetInnerHTML={{__html:item.title}}></Link>
											</li>
										)
									}
								}
							)}
						</ul>
					</header>
	
					<div className="c-menu">
						<a href="#" className="c-menu__close" onClick={handleMenuToggle}>Close</a>
						<ul className="c-menu__list c-menu__load-effect">
							{global.json.menu.map((item,i) =>
								{
									let location = window.location + '';
									let linkClass = 'c-menu__link';
									if (location.indexOf(item.url) !== -1) {
										linkClass = 'c-menu__link state-active';
									}										
									return (
										<li className="c-menu__item">
											<Link to={{ pathname: item.url }} className={linkClass} dangerouslySetInnerHTML={{__html:item.title}}></Link>
										</li>
									)
								}
							)}
						</ul>
						<a href={global.json.instagram} className="c-menu__instagram">Instagram</a>
					</div>
					
				</>
			)
		
		} else {
			
			return null;
			
		}
		
	} else {
		
		return null;
		
	}
		
}
export default WithConsumer(Header);